/*****************************************************************
 *  ZOHO BRIDGE PANEL — THE THIN-LINE ICONS                        *
 *  File: apps/web/src/pages/bridge/bridgeIcons.js                 *
 *  What it does: one small family of thin-line icons (1.5 stroke, *
 *  24 box, round ends), drawn in the text colour so they follow   *
 *  light, dark and high-contrast themes. Every icon sits next to  *
 *  a word; colour and icons never carry meaning alone.            *
 *  Reads: nothing.   Writes: nothing.                             *
 *****************************************************************/

import React from 'react';

// The drawing for each icon, as SVG path data.
const ICON_PATHS = {
  inbox: 'M3 13h5l1.5 3h5L16 13h5M5 5h14l2 8v6H3v-6l2-8z',
  tag: 'M3 12V4h8l10 10-8 8L3 12zM7.5 7.5h.01',
  people: 'M9 11a4 4 0 100-8 4 4 0 000 8zM2 21v-1a6 6 0 0112 0v1M16 11a3 3 0 100-6M22 21v-1a5 5 0 00-4-4.9',
  key: 'M14 10a4 4 0 10-4 4M10 14l-7 7M6 17l2 2M8 15l2 2',
  list: 'M8 6h13M8 12h13M8 18h13M3.5 6h.01M3.5 12h.01M3.5 18h.01',
  check: 'M4 12l5 5L20 6',
  cross: 'M6 6l12 12M18 6L6 18',
  clock: 'M12 21a9 9 0 100-18 9 9 0 000 18zM12 7v5l3 3',
  alert: 'M12 3l10 18H2L12 3zM12 10v4M12 17.5h.01',
  link: 'M10 14a4 4 0 005.7 0l3-3a4 4 0 00-5.7-5.7l-1 1M14 10a4 4 0 00-5.7 0l-3 3a4 4 0 005.7 5.7l1-1',
  copy: 'M8 8h12v12H8zM4 16V4h12',
  history: 'M3 12a9 9 0 109-9 9 9 0 00-7 3.4M3 4v4h4M12 8v4l3 2',
  // phase 2b (2026-10-13): a house for properties, a heartbeat for health,
  // a magnifier for search, a stop square, a stack for "every field"
  home: 'M3 11l9-7 9 7M5 10v10h5v-6h4v6h5V10',
  pulse: 'M3 12h4l2-5 4 10 2-5h6',
  search: 'M11 18a7 7 0 100-14 7 7 0 000 14zM21 21l-5-5',
  stop: 'M7 7h10v10H7z',
  stack: 'M12 3l9 5-9 5-9-5 9-5zM3 13l9 5 9-5M3 17l9 5 9-5',
  // Phase 2a (2026-10-13): visits and technicians, same thin-line family.
  calendar: 'M4 6h16v14H4zM4 10h16M8 3v4M16 3v4',
  usercheck: 'M9 11a4 4 0 100-8 4 4 0 000 8zM2 21v-1a6 6 0 0112 0v1M16 11l2 2 4-4',
  flag: 'M5 21V4M5 4h11l-2 4 2 4H5',
  pin: 'M12 21s-7-6.2-7-11.5a7 7 0 0114 0C19 14.8 12 21 12 21zM12 12a2.5 2.5 0 100-5 2.5 2.5 0 000 5z',
};

/* ---- BridgeIcon({ name, size }) --------------------------------
   Draws one icon. It is decoration: screen readers skip it,
   because the word next to it already says what it means.     */
export function BridgeIcon({ name, size }) {
  const iconSize = size || 20;
  const pathData = ICON_PATHS[name] || ICON_PATHS.list;

  return (
    <svg
      width={iconSize}
      height={iconSize}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      className="zb-icon"
    >
      <path d={pathData} />
    </svg>
  );
}
